import React from "react";

const ctx = () => {
  const resumeDataURL =
    "https://drive.google.com/file/d/15TWhSlKLmwM92-LAYwUkimIz3iMDlutO/view?usp=sharing";

  return (
    <div className="ctx">
      <a
        href={resumeDataURL}
        target="_blank"
        rel="noopener noreferrer"
        // download={resume}
        className="btn"
      >
        View Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        {" "}
        Let's Connect
      </a>
    </div>
  );
};

export default ctx;
